export default class Popup {
  overlay = document.getElementById('shadow-overlay');
  popup = document.getElementById('popup');
  popupClass = 'js-popup';
  popupContent = document.getElementById('popup-content');
  closeButton = document.getElementById('popup-close-icon');

  show = (content) => {
    this.popupContent.appendChild(content);
    this.popup.classList.remove('hidden');
    this.overlay.classList.remove('hidden');
  };

  close = () => {
    this.popupContent.innerHTML = '';
    this.popup.classList.add('hidden');
    this.overlay.classList.add('hidden');
  };

  closeOnOverlay = ({ target }) => {
    if (target.classList.contains(this.popupClass)) {
      this.close();
    }
  };

  initializeEventListeners = () => {
    this.closeButton.addEventListener('click', this.close);
    this.popup.addEventListener('click', this.closeOnOverlay);
  };
}
